import { render, staticRenderFns } from "./TermsAndConditionsPage.vue?vue&type=template&id=6882a58d&"
import script from "./TermsAndConditionsPage.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports